<ng-template #promptTemplate>
  <div class="site-switch-card" role="alertdialog" aria-live="assertive" aria-labelledby="siteSwitchTitle">
    <div class="site-switch-card-icon">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
        <path
          d="M4 7h13M17 7l-3-3M17 7l-3 3M20 17H7M7 17l3 3M7 17l3-3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="site-switch-card-content">
      <p id="siteSwitchTitle" class="site-switch-card-title">
        This record belongs to <strong>{{ sites.pendingSwitch?.siteName }}</strong>
      </p>
      <p class="site-switch-card-body">Switch your active clinic to open it.</p>
      <div class="site-switch-card-error" *ngIf="sites.switchError">{{ sites.switchError }}</div>
      <div class="site-switch-card-actions">
        <button type="button" class="site-switch-card-btn site-switch-card-btn--ghost" (click)="sites.cancelSwitch()">
          Cancel
        </button>
        <button
          type="button"
          class="site-switch-card-btn site-switch-card-btn--primary"
          (click)="sites.confirmSwitch()"
        >
          Switch &amp; Open
        </button>
      </div>
    </div>
  </div>
</ng-template>
